import { Networks } from "./blockchain";

const MATIC_ADDRESSES = {
    MASTER_MANTIS_ADDRESS: "0x2c1Ded27522E317515e5B5e856De7293938b6D1E",
    POOL_ADDRESS: "0x62Ba5e1AB1fa304687f132f67E35bFC5247166aD",
    MNTS_ADDRESS: "0xE92175Ea10FC1F59F633c77153e81780A6EEaE04",
    VEMNT_ADDRESS: "0xBb919023638201BfA66157A7EBA6302795A3DDD4",
    ASSET_USDC_ADDRESS: "0xe03aec0d08B3158350a9aB99f6Cea7bA9513B889",
    ASSET_USDT_ADDRESS: "0xe8A1eAD2F4c454e319b76fA3325B754C47Ce1820",
    ASSET_DAI_ADDRESS: "0x4b3BFcaa4F8BD4A276B81C110640dA634723e64B",
    USDC_ADDRESS: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
    USDT_ADDRESS: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
    DAI_ADDRESS: "0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063",
    AIRDROP_ADDRESS: "0x2AdeDCfD726e03032dDEf1241D5C8eFAd40C1F80",
    MNT_VERIFY_ADDRESS: "0xC9c7eA75314f47dAB32c5580466f0866A8b15A9C",
    EMNTS_ADDRESS: "0x2B99145FaC25B86a81f4Dc9fEdAeb25aA93037c0",
    POOL_WEETH_ADDRESS: "",
    ASSET_WETH_ADDRESS: "",
    ASSET_WEETH_ADDRESS: "",
    ASSET_NWEETH_ADDRESS: "",
    WETH_ADDRESS: "",
    WEETH_ADDRESS: "",
    NWEETH_ADDRESS: "",
};

// const MATIC_ADDRESSES = {
//     MASTER_MANTIS_ADDRESS: "0x16f5b2F88616EADe19A7FcBd87dA5B56B1e78480",
//     POOL_ADDRESS: "0xC713cd5fC89986c5ee2E2Ffc36fA820bBe6d9b4E",
//     MNTS_ADDRESS: "0x8bC4310Fd1B702d2A434Ac53aBd613295e5D33d6",
//     VEMNT_ADDRESS: "0x62137317F55F8989D2A2573D0513F5Df6643348d",
//     ASSET_USDC_ADDRESS: "0xA90a9F16d6f16777b3035CD34Fe6Cdf9E5A5F50c",
//     ASSET_USDT_ADDRESS: "0x781a7A3ED5689197f8aa7F21926f03b82844D705",
//     ASSET_DAI_ADDRESS: "0x155db3fE34c33D9Cd8A7165924282836C01e41a5",
//     USDC_ADDRESS: "0x00DD5fBAd5c8BD50AA8bDAeC5806A7364316d5E3",
//     USDT_ADDRESS: "0x108C8E2039Fed07B0f63E021e2ED7dED3D12DC45",
//     DAI_ADDRESS: "0x62675cf7d42f6F76f6Bfe82092dAd79Ff0E15f53",
//     AIRDROP_ADDRESS: "0x2AdeDCfD726e03032dDEf1241D5C8eFAd40C1F80",
// };

const ZK_ADDRESSES = {
    MASTER_MANTIS_ADDRESS: "0x4af97f73343b226C5a5872dCd2d1c4944BDb3E77",
    POOL_ADDRESS: "0x12d41b6DF938C739F00c392575e3FD9292d98215",
    MNTS_ADDRESS: "0x375488F097176507e39B9653b88FDc52cDE736Bf",
    VEMNT_ADDRESS: "0x714023acef728603686Dd5b186aD1c7052dBC896",
    ASSET_USDC_ADDRESS: "0x9b7bcEA67049819F4B35E84468c5E87918Aefe4B",
    ASSET_USDT_ADDRESS: "0x3b92B5e8e72A016991CC399241A6A4659f7073f4",
    ASSET_DAI_ADDRESS: "0xFe825CC878b25420d4b5Df5C68DDCDe8BF3947A8",
    USDC_ADDRESS: "0xA8CE8aee21bC2A48a5EF670afCc9274C7bbbC035",
    USDT_ADDRESS: "0x1E4a5963aBFD975d8c9021ce480b42188849D41d",
    DAI_ADDRESS: "0xC5015b9d9161Dca7e18e32f6f25C4aD850731Fd4",
    AIRDROP_ADDRESS: "",
    MNT_VERIFY_ADDRESS: "0x7dACa620814100196C76EcB23D6A206219f5af89",
    EMNTS_ADDRESS: "0x26452386EE5A66a5a7e25Be5123E170b7651Fb9c",
    POOL_WEETH_ADDRESS: "",
    ASSET_WETH_ADDRESS: "",
    ASSET_WEETH_ADDRESS: "",
    ASSET_NWEETH_ADDRESS: "",
    WETH_ADDRESS: "",
    WEETH_ADDRESS: "",
    NWEETH_ADDRESS: "",
};

const MODE_ADDRESSES = {
    MASTER_MANTIS_ADDRESS: "0x8997E7669dA8451E356472cf3ef33DfBc9D7b448",
    POOL_ADDRESS: "0x4af97f73343b226C5a5872dCd2d1c4944BDb3E77",
    MNTS_ADDRESS: "0xF45bF7d8934C898df2ad9c365EaE4991b2dfd33D",
    VEMNT_ADDRESS: "0xDA4F88fD4B55d03433fA243d1f98F5618A82bA41",
    ASSET_USDC_ADDRESS: "0x967f594f73930A02817DAF3112CCC7F2C611dEF8",
    ASSET_USDT_ADDRESS: "0x12d41b6DF938C739F00c392575e3FD9292d98215",
    ASSET_DAI_ADDRESS: "",
    USDC_ADDRESS: "0xd988097fb8612cc24eeC14542bC03424c656005f",
    USDT_ADDRESS: "0xf0F161fDA2712DB8b566946122a5af183995e2eD",
    DAI_ADDRESS: "",
    AIRDROP_ADDRESS: "",
    MNT_VERIFY_ADDRESS: "0xBb919023638201BfA66157A7EBA6302795A3DDD4",
    EMNTS_ADDRESS: "0x2c1Ded27522E317515e5B5e856De7293938b6D1E",
    POOL_WEETH_ADDRESS: "0xe8A1eAD2F4c454e319b76fA3325B754C47Ce1820",
    ASSET_WETH_ADDRESS: "0x4b3BFcaa4F8BD4A276B81C110640dA634723e64B",
    ASSET_WEETH_ADDRESS: "0xA56b52D7a8f3cbB3b4261501c60a7Ea95aCaafb4",
    ASSET_NWEETH_ADDRESS: "0x7bCad0e76c7623F352C311BbA25d24fB16D73cCb",
    WETH_ADDRESS: "0x4200000000000000000000000000000000000006",
    WEETH_ADDRESS: "0x028227c4dd1e5419d11Bb6fa6e661920c519D4F5",
    NWEETH_ADDRESS: "0x04C0599Ae5A44757c0af6F9eC3b93da8976c150A",
};

export const getAddresses = (networkID: number) => {
    if (networkID === Networks.MATIC) return MATIC_ADDRESSES;
    if (networkID === Networks.ZK) return ZK_ADDRESSES;
    if (networkID === Networks.MODE) return MODE_ADDRESSES;

    throw Error("Network don't support");
};

const MATIC_CONSTANTS = {
    mntsPerBlock: 0,
    blocksPerDay: 43200,
};

const ZK_CONSTANTS = {
    mntsPerBlock: 0,
    blocksPerDay: 43200,
};

const MODE_CONSTANTS = {
    mntsPerBlock: 0,
    blocksPerDay: 43200,
};

export const getChainConstantData = (networkID: number) => {
    if (networkID === Networks.MATIC) return MATIC_CONSTANTS;
    if (networkID === Networks.ZK) return ZK_CONSTANTS;
    if (networkID === Networks.MODE) return MODE_CONSTANTS;

    throw Error("Network don't support");
};
